import React from 'react';
import Shape from 'ati-ui-react/components/Shape';
import classnames from 'classnames';
import Icons from '../Icons';
import Recommendations from '../Recommendations';
import Claims from '../Claims';
import * as styles from './RatingRow.scss';
import * as headerStyles from '../RatingHeader/RatingHeader.scss';
import Firm from '../Firm';
import { makePassportRatingUrl } from '../../utils/urlProvider';
import { openPassportPopup } from '../../utils';
import RatingRowPosition from '../RatingRowPosition';

const RatingRow = ({ row, selectedRow }) => {
  const {
    position,
    firm: {
      atiId,
    },
  } = row;
  const url = makePassportRatingUrl(atiId);
  const isSelected = position === selectedRow;

  return (
    <Shape
      shadow
      className={classnames(styles.row, { [styles.selected]: isSelected })}
      onClick={e => openPassportPopup(e, url)}
    >
      <div className={headerStyles.counter}>
        <RatingRowPosition position={row.position} />
        <Firm row={row} />
      </div>
      <Icons row={row} />
      <Recommendations row={row} isMobile={false} />
      <Claims row={row} />
    </Shape>
  );
};

export default RatingRow;
